
<template>

  <div class="container" style="width: 100vw; height: 100vh;">
    <!-- <div class="card" style="padding: 30px;height: 90vh;">
    <div class="card-body" > -->
    <!-- <span class="text-danger fs-3 fw-bold">LTC Red Army</span> -->
    <div class="row justify-content-center" style="width: 100%;padding-left: 30px;">
      <img src="../assets/images/logo.png" style="height: 50vh;width: fit-content;min-width: 350px;"/>
    </div>
    <div class="row justify-content-center" style="padding-top: 70px;padding-left: 10px;padding-right: 10px;">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-xs-12 col-sm-3 ">
                  <label for="username" class="form-label fw-bold">
                    LTC-ID
                  </label>
                  </div>
                  <div class="col-xs-12 col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      id="username"
                      placeholder="Please enter your ID"
                      v-model="username"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-success" @click="submitLoginForm();">
                  Request OTP
                </button>
              </div>
    </div>

  </div>
 
</template>

<script>
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'LoginPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
      username: ""
    };
  },
  methods: {
    async submitLoginForm() {
      var vm = this;
      vm.showLoading();
      return await axios.post(Global.backendPath+"login", {"username":(vm.username).toUpperCase(),
      "password":"PW6p0XgkSAZB7qeV4nJjcLzDiUuFl95No8HxrEfsCR2tv"})
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.token_object){
          // Global.userIdentify = response.data.user_id;
          Global.token = "Bearer "+response.data.token_object.token;
          localStorage.setItem("token",Global.token)
          // localStorage.setItem("userId",response.data.user_id)
          Global.userName = vm.username;
          localStorage.setItem("username",vm.username);
          vm.$router.push("/otp");
        }
      }).catch((error) => {
        console.log("error",error);
        if (error.response&&error.response.status === 401) {
          vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: 'Invalid account!',
          })
          //To show internal error message!
        }else if(error&&error.response&&error.response.data){
          vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: error.response.data,
          })
        }
        vm.hideLoading();
        console.log(error);
      });
    },
  },
  created() {
    
  }
};
</script>

<style>
</style>
